import { io, Socket } from "socket.io-client";
import { API_BASE } from "../config/api-url";

let socket: Socket | null = null;

export function getSocket(): Socket {
	if (!socket) {
		socket = io(`${API_BASE}/messages`, {
			autoConnect: false,
			transports: ["websocket"],
			withCredentials: true,
		});
	}
	return socket;
}

export function connectSocket(): Socket {
	const s = getSocket();
	if (!s.connected) s.connect();
	return s;
}

export function disconnectSocket(): void {
	socket?.disconnect();
}
